import {
  HttpErrorResponse,
  type HttpEvent,
  type HttpHandlerFn,
  type HttpInterceptorFn,
  type HttpRequest,
} from '@angular/common/http';
import { type Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { type ErrorHandlerContext, selectErrorHandler } from './error-handling';
import { Logger } from '@app/utils';

const logger: Logger = Logger.get('ErrorInterceptor');

export const errorInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const matDialogService = inject(MatDialog);

  return next(request).pipe(
    catchError(error => {

      // Only process HttpErrorResponse objects
      if (!(error instanceof HttpErrorResponse)) {
        return throwError(() => error);
      }

      const context: ErrorHandlerContext = {
        request,
        next,
        authService,
        router,
        matDialogService
      };

      logger.debug('ErrorInterceptor - ErrorHandlerContext:', context);

      const errorHandler = selectErrorHandler(error.status);

      return errorHandler(error, context);
    })
  );
};
